import { Handle, Position } from "@xyflow/react";
import { ApiOutlined, ThunderboltOutlined } from "@ant-design/icons";
import {
  CollectorOutputReadable,
  Measurement,
} from "../../../../../../services/client/types.gen";
import { find } from "lodash";
import { useMemo } from "react";

function CollectorNode({
  data,
  measurements,
}: {
  data: CollectorOutputReadable;
  measurements?: Measurement[];
}) {
  const measurement = useMemo(
    () =>
      find(
        measurements,
        (measurement: Measurement) => measurement.source.asset_id === data.name,
      ),
    [measurements, data.name],
  );

  const isActive = (measurement?.powerValue ?? 0) > 0;

  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-gray-200 border-2 border-stone-400">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div
            className={`rounded-full w-12 h-12 flex justify-center items-center ${isActive ? "bg-green-100" : "bg-gray-100"}`}
          >
            <ApiOutlined />
          </div>
          <div className="ml-2">
            <div className="text-lg font-bold">{data.name}</div>
            <div className="text-gray-500">
              line_current: {data.line_current} amp
            </div>
          </div>
        </div>
      </div>

      {measurement && (
        <div className="mt-2 flex items-center space-x-2">
          <ThunderboltOutlined className="h-6 w-6 text-yellow-500" />{" "}
          <div className="text-3xl font-bold text-gray-800">
            {Math.round(measurement.powerValue)}
          </div>
          <span className="text-sm text-gray-500">w</span>
        </div>
      )}
      <Handle
        type="target"
        position={Position.Top}
        className="w-16 !bg-teal-500"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className="w-16 !bg-teal-500"
      />
    </div>
  );
}

export default CollectorNode;
